import { createRouter, createWebHistory } from "vue-router";
import routes from "./routes";

const router = createRouter({
    linkActiveClass: "active",
    history: createWebHistory(),
    routes,
    scrollBehavior() {
        return { top: 0 };
    },
});

export default router;
